import { render, staticRenderFns } from "./OrderCode.vue?vue&type=template&id=1c169964&scoped=true&"
import script from "./OrderCode.vue?vue&type=script&lang=js&"
export * from "./OrderCode.vue?vue&type=script&lang=js&"
import style0 from "./OrderCode.vue?vue&type=style&index=0&id=1c169964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c169964",
  null
  
)

export default component.exports